<template>
  <!-- 模板弹出框 -->
  <Modal
    v-model="isShow"
    width="700"
    :title="isEdit ? '编辑发票模板' : '新增发票模板'"
    :mask-closable="false"
    :loading="loading"
    @on-ok="editList('editListTypeForm')"
  >
  </FormItem>
    <Form
      ref="editListTypeForm"
      label-position="right"
      :label-width="120"
      :rules="ruleValidate"
      :model="editListTypeForm"
    >
      <FormItem label="模板名称"
        label-for="name"
        prop="name">
        <Input
          placeholder="请输入模板名称"
          element-id="name"
          v-model="editListTypeForm.name"
        ></Input>
      </FormItem>
      <FormItem label="发票抬头"
        label-for="title"
        prop="title">
        <Input
          placeholder="请输入发票抬头"
          element-id="title"
          v-model="editListTypeForm.title"
        ></Input>
      </FormItem>
      <FormItem label="纳税人识别号"
        label-for="taxpayer_number"
        prop="taxpayer_number">
        <Input
          placeholder="请输入纳税人识别号"
          element-id="taxpayer_number"
          v-model="editListTypeForm.taxpayer_number"
        ></Input>
      </FormItem>
      <FormItem label="开户行"
        label-for="bank_name"
        prop="bank_name">
        <Input
          placeholder="请输入开户行"
          element-id="bank_name"
          v-model="editListTypeForm.bank_name"
        ></Input>
      </FormItem>
      <FormItem label="对公账号"
        label-for="bank_account"
        prop="bank_account">
        <Input
          placeholder="请输入对公账号"
          element-id="bank_account"
          v-model="editListTypeForm.bank_account"
        ></Input>
      </FormItem>
      <FormItem label="收件地址"
        label-for="register_addr"
        prop="register_addr">
        <Input
          placeholder="请输入收件地址"
          element-id="register_addr"
          v-model="editListTypeForm.register_addr"
        ></Input>
      </FormItem>
      <FormItem label="公司电话"
        label-for="company_phone"
        prop="company_phone">
        <Input
          placeholder="请输入公司电话"
          element-id="company_phone"
          v-model="editListTypeForm.company_phone"
        ></Input>
      </FormItem>
      <FormItem label="收件人"
        label-for="recipients_name"
        prop="recipients_name">
        <Input
          placeholder="请输入收件人"
          element-id="recipients_name"
          v-model="editListTypeForm.recipients_name"
        ></Input>
      </FormItem>
      <FormItem label="收件人手机号"
        label-for="recipients_phone"
        prop="recipients_phone">
        <Input
          placeholder="请输入收件人手机号"
          element-id="recipients_phone"
          v-model="editListTypeForm.recipients_phone"
        ></Input>
      </FormItem>
      <FormItem label="邮政编码"
        label-for="recipients_postcode"
        prop="recipients_postcode">
        <Input
          placeholder="请输入邮政编码"
          element-id="recipients_postcode"
          v-model="editListTypeForm.recipients_postcode"
        ></Input>
      </FormItem>
      <FormItem label="收件地址"
        label-for="recipients_addr"
        prop="recipients_addr">
        <Input
          placeholder="请输入收件地址"
          element-id="recipients_addr"
          v-model="editListTypeForm.recipients_addr"
        ></Input>
      </FormItem>
    </Form>
  </Modal>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: true
    },
    isEdit: {
      type: Boolean,
      required: true
    },
    invoiceDetail: {
      type: Object,
      required: true
    },
    rowId: {
      type: Number
    }
  },
  data () {
    return {
      isShow: this.value,
      loading: true,
      editListTypeForm: {
        id: '',
        name: '',
        title: '',
        taxpayer_number: '',
        bank_name: '',
        bank_account: '',
        register_addr: '',
        company_phone: '',
        recipients_name: '',
        recipients_phone: '',
        recipients_postcode: '',
        recipients_addr: ''
      },
      ruleValidate: {
        name: [
          { required: true, message: '请输入模板名称', trigger: 'string' }
        ],
        title: [
          { required: true, message: '请输入发票抬头', trigger: 'string' }
        ],
        taxpayer_number: [
          { required: true, message: '请输入纳税人识别号', trigger: 'string' }
        ],
        bank_name: [
          { required: true, message: '请输入开户行', trigger: 'string' }
        ],
        bank_account: [
          { required: true, message: '请输入对公账号', trigger: 'string' }
        ],
        register_addr: [
          { required: true, message: '请输入收件地址', trigger: 'string' }
        ],
        company_phone: [
          { required: true, message: '请输入公司电话', trigger: 'string' }
        ],
        recipients_name: [
          { required: true, message: '请输入收件人', trigger: 'string' }
        ],
        recipients_phone: [
          { required: true, message: '请输入收件人手机号', trigger: 'string' }
        ],
        recipients_postcode: [
          { required: true, message: '请输入邮政编码', trigger: 'string' }
        ],
        recipients_addr: [
          { required: true, message: '请输入收件地址', trigger: 'string' }
        ]
      }
    }
  },
  watch: {
    value (val) {
      this.isShow = val
      if (val) {
        this.reload()
      } else {
        this.$refs.editListTypeForm.resetFields()
        this.editListTypeForm.id = ''
      }
    },
    isShow (val) {
      this.$emit('input', val)
    }
  },
  methods: {
    reload () {
      if (this.isEdit) {
        this.editListTypeForm.id = this.rowId
        this.editListTypeForm.name = this.invoiceDetail.name
        this.editListTypeForm.title = this.invoiceDetail.title
        this.editListTypeForm.taxpayer_number = this.invoiceDetail.taxpayer_number
        this.editListTypeForm.bank_name = this.invoiceDetail.bank_name
        this.editListTypeForm.bank_account = this.invoiceDetail.bank_account
        this.editListTypeForm.register_addr = this.invoiceDetail.register_addr
        this.editListTypeForm.company_phone = this.invoiceDetail.company_phone
        this.editListTypeForm.recipients_name = this.invoiceDetail.recipients_name
        this.editListTypeForm.recipients_phone = this.invoiceDetail.recipients_phone
        this.editListTypeForm.recipients_postcode = this.invoiceDetail.recipients_postcode
        this.editListTypeForm.recipients_addr = this.invoiceDetail.recipients_addr
      }
    },
    editList (val) {
      setTimeout(() => {
        this.loading = false
        setTimeout(() => { this.loading = true }, 100)
      }, 1000)
      this.$refs[val].validate((valid) => {
        if (valid) {
          let data = {
            ...this.editListTypeForm
          }
          let url = '/invoiceTmpl'
          if (this.isEdit) {
            this.$http.put(url, data).then(res => {
              if (res.success) {
                let msg = '修改成功'
                this.$Message.success(msg)
                this.isShow = false
                this.$emit('on-success')
              } else {
                this.$Message.error(res.message)
              }
            })
          } else {
            this.$http.post(url, data).then(res => {
              if (res.success) {
                let msg = '新增成功'
                this.$Message.success(msg)
                this.isShow = false
                this.$emit('on-success')
              } else {
                this.$Message.error(res.message)
              }
            })
          }
        }
      })
    }
  }
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/pages/invoiceManage/agInvoiceTemplate/AddInvoice.vue